import React, { useState } from "react";
import { Modal, Button } from "react-bootstrap";

function FileModal({ show, onHide, folderId, fileId, name, children, onDelete }) {
	const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
	
	const handleDeleteClick = async () => {
		if (showDeleteConfirm) {
			try {
				console.log("Deleting file:", fileId, "from folder:", folderId);
				if (onDelete) {
					await onDelete(fileId, folderId);
				}
				onHide(); // Close modal only after successful deletion
			} catch (error) {
				console.error("Failed to delete file:", error);
				// Optionally show an error message to the user
				// You could add error state management here if needed
			}
		} else {
			setShowDeleteConfirm(true);
			setTimeout(() => {
				setShowDeleteConfirm(false);
			}, 3000);
		}
	};

	return (
		<Modal show={show} onHide={onHide} size="lg" centered>
			<Modal.Header closeButton>
				<Modal.Title>{name}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{children /* e.g. your main content, preview, etc. */}

				<div className="mt-3 d-flex justify-content-end">
					<Button variant="danger" size="sm" onClick={handleDeleteClick}>
						{showDeleteConfirm
							? "Click again to confirm delete"
							: "Delete File"}
					</Button>
				</div>
			</Modal.Body>
		</Modal>
	);
}

export default FileModal;
